module.exports = __webpack_public_path__ + "static/media/free-scrap-removal-toowoomba.4282c285.png";